import { createFeatureSelector, createSelector } from '@ngrx/store';

import { serviceWorkerFeatureKey, ServiceWorkerState } from 'app/state/service-worker/service-worker.reducer';

export const selectServiceWorkerState = createFeatureSelector<ServiceWorkerState>(serviceWorkerFeatureKey);

export const selectIsUpdateAvailable = createSelector(
    selectServiceWorkerState,
    (state) => state.isUpdateAvailable,
);
